import { regionSupportedLanguages } from 'hooks/use-set-user-locale/regionLanguages';
import { PROD_SUPPORTED_REGIONS, loadLanguage, loadRegion } from 'state/intl/hook';
import { PROD_DEFAULT_LANGUAGE } from 'state/intl/supported-languages';
import { PROD_DEFAULT_REGION } from 'state/intl/supported-regions';
import { country } from 'utils/environment';

import { REGIONAL_APP } from './constants';

export const loadLocale = () => {
  if (REGIONAL_APP) {
    const region = country?.toUpperCase();

    const hasMultipleLanguages = region && regionSupportedLanguages[region].size > 1;
    // If region has multiple languages, access language from selection history (or default if not available)
    // otherwise lock in default language
    const language = hasMultipleLanguages ? loadLanguage() : PROD_DEFAULT_LANGUAGE;
    const supportedRegion = PROD_SUPPORTED_REGIONS[region] || PROD_DEFAULT_REGION;

    return { language, region: supportedRegion };
  }
  return { language: loadLanguage(), region: loadRegion() };
};
